export default class DeviceImage {
   static render = (device, scale = 1) => {
      return `<div class="space" style="width:${device.width / scale * SIZE.pxInMm}px; height:${BASE_HEIGHT_MM / scale}mm !important"></div>`
   }
}
